<template>
  <!-- 人物特征 -->
  <div>
    <div class="flex flex-col gap-2 px-4">
      <div class="flex justify-between items-center mt-4">
        <div class="font-bold">
          {{ t(`painting.people.feature`) }}
        </div>
        <div>
          <button
            class="btn btn-xs rounded"
            @click="showCreateTraitModal = true"
          >
            {{ t(`painting.people.new`) }}
          </button>
        </div>
      </div>
      <div class="flex relative pr-7" v-if="selectedTrait">
        <!-- <VanField
          v-model="matePrompt"
          :autosize="{ maxHeight: 90, minHeight: 20 }"
          rows="1"
          class="pr-10"
          type="textarea"
        /> -->

        <InputTag
          class="w-full"
          v-model:prompt="matePrompt"
          :show-negative="false"
          :show-upgrade-prompt="false"
        />
        <button
          class="absolute right-1 bottom-4 btn btn-primary btn-xs"
          @click="showCharacterEditModal = true"
        >
          <i class="iconify mingcute--edit-3-line"></i>
        </button>
      </div>
      <mate-trait-selection
        enable-selection
        enable-edit
        enable-selection-lock
        :selected-trait="selectedTrait"
        @update:selected-trait="clickSelectedTrait"
        @update:showCreateTraitModal="showCreateTraitModal = $event"
      />

      <!-- 人物 -->
      <EditPromptsContainer
        mode="character"
        v-model:prompt="matePrompt"
        :has-preview="false"
        v-model:show-modal="showCharacterEditModal"
        :has-negative="false"
      />
    </div>
    <!-- 表情 -->
    <EditPromptsContainer
      mode="faceExpression"
      v-model:prompt="mate.faceExpression.prompt"
      v-model:negative-prompt="mate.faceExpression.negativePrompt"
    >
      <template #left>
        <i class="iconfont icon-emoji mr-1"></i>
        <span class="font-bold">
          {{ t(`painting.people.faceExpression`) }}
        </span>
      </template>
    </EditPromptsContainer>

    <!-- 姿势 -->
    <EditPromptsContainer
      mode="pose"
      v-model:prompt="mate.pose.prompt"
      v-model:negative-prompt="mate.pose.negativePrompt"
      :is-unlimited="reqData.isUnlimited"
    >
      <template #left>
        <i class="iconfont icon-pray mr-1"></i>
        <span class="font-bold">
          {{ t(`painting.people.pose`) }}
        </span>
      </template>
    </EditPromptsContainer>
    <!-- 服饰 -->
    <EditPromptsContainer
      mode="clothing"
      v-model:prompt="mate.clothing.prompt"
      v-model:negative-prompt="mate.clothing.negativePrompt"
      :is-unlimited="reqData.isUnlimited"
    >
      <template #left>
        <i class="iconfont icon-tshirt mr-1"></i>
        <span class="font-bold">
          {{ t(`painting.people.clothing`) }}
        </span>
      </template>
    </EditPromptsContainer>

    <EditPromptsContainer
      v-if="reqData.isUnlimited"
      mode="other"
      v-model:prompt="mate.clothing.prompt"
      v-model:negative-prompt="mate.clothing.negativePrompt"
      :is-unlimited="reqData.isUnlimited"
    >
      <template #left>
        <i class="iconfont icon-heart-fill mr-1"></i>
        <span class="font-bold"> NSFW </span>
      </template>
    </EditPromptsContainer>
  </div>

  <CreateTraitPresetModal v-model:show="showCreateTraitModal" />
</template>

<script lang="ts" setup>
import { useMateTrait } from "@/stores/mateTrait";
import { ref, PropType, watch, onMounted } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps({
  mate: {
    type: Object as PropType<PromptJsonMateTrait>,
    required: true,
  },
  reqData: {
    type: Object as PropType<PromptJson>,
    required: true,
  },
});
const emit = defineEmits(["update:selectTrait"]);

const trait = useMateTrait();
const { t } = useI18n();

const showCreateTraitModal = ref(false);

// 人物特征
const selectedTrait = ref<MateTrait | null>();
const showCharacterEditModal = ref(false);
// 选择特征
const matePrompt = ref("");
const clickSelectedTrait = (trait: MateTrait | null) => {
  selectedTrait.value = trait;
  matePrompt.value = trait?.prompt ?? "";
};

watch(matePrompt, (val) => (props.mate.prompt = val || ""));

watch(selectedTrait, (val) => (props.mate.id = val?.id || undefined));

onMounted(async () => {
  if (props.mate.id) {
    selectedTrait.value = await trait.getOrFetchTraitItem(props.mate.id);
    matePrompt.value = props.mate.prompt ?? selectedTrait.value?.prompt ?? "";
  }
});
</script>
